// Registro em memória dos tickets com chamada ativa no painel do atendente.
// Evita que o aviso de "chamada entrando" apareça quando o atendente já está
// numa chamada daquele ticket (ex.: ele mesmo iniciou).
const active = new Set();

export const markCallActive = (id) => active.add(String(id));
export const clearCallActive = (id) => active.delete(String(id));
export const isCallActive = (id) => active.has(String(id));
